import { render } from "./DeleteNoteModal.vue?vue&type=template&id=55d92be9&scoped=true"
import script from "./DeleteNoteModal.vue?vue&type=script&lang=js"
export * from "./DeleteNoteModal.vue?vue&type=script&lang=js"

import "./DeleteNoteModal.vue?vue&type=style&index=0&id=55d92be9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d92be9"]])

export default __exports__